import EmailTemplateDetailView from '@/views/admin/email.templates/EmailTemplateDetailView.vue';
import EmailTemplateListingView from '@/views/admin/email.templates/EmailTemplateListingView.vue';
import FormTemplateDetailView from '@/views/admin/form.templates/FormTemplateDetailView.vue';
import FormTemplateListingView from '@/views/admin/form.templates/FormTemplateListingView.vue';
import SettingsView from '@/views/admin/settings/SettingsView.vue';

export const adminSettingsRoutes = [
  {
    path: '/admin/settings/:tabName?',
    name: 'AdminSettings',
    component: SettingsView,
    meta: { guest: false },
  },
  {
    path: '/admin/email/template/listing',
    name: 'AdminEmailTemplateListings',
    component: EmailTemplateListingView,
    meta: { guest: false },
  },
  {
    path: '/admin/email/template/:emailTemplateId/edit',
    name: 'AdminEmailTemplateDetail',
    component: EmailTemplateDetailView,
    meta: { guest: false },
  },
  {
    path: '/admin/form/template/listing',
    name: 'AdminFormTemplateListings',
    component: FormTemplateListingView,
    meta: { guest: false },
  },
  {
    path: '/admin/form/template/:formTemplateId/edit',
    name: 'AdminFormTemplateDetail',
    component: FormTemplateDetailView,
    meta: { guest: false },
  },
];
